import { useToasts } from 'providers/ToastsProvider';

import Toast from './Toast';

function Toasts() {
  const { toasts, removeToast } = useToasts();

  return (
    <div data-testid="toasts" className="fixed inset-x-0 bottom-0 z-50 p-4">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          dismiss={() => removeToast(toast.id)}
          className="mb-2 last:mb-0"
        />
      ))}
    </div>
  );
}

export default Toasts;
